import { GzAntimalwareExclusionsWebComponent } from './component/GzAntimalwareExclusionsWebComponent';

export { GzAntimalwareExclusionsWebComponent };
